import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const SectionHeader = ({ icon: Icon, title, description, iconColor = "primary.main" }) => (
  <Paper sx={{ p: 2, mb: 2 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Icon sx={{ fontSize: 32, color: iconColor }} />
      <Box>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Box>
  </Paper>
);

export default SectionHeader;
